import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { PatchPayload } from "./types"

export class Service {
    static fetch () {
        return AppContext.getApiClient().get("/inventory-configuration")
    }

    static patch (configId: string, payload: PatchPayload) {
        return AppContext.getApiClient().patch(`/inventory-configuration/${configId}`, payload)
    }
}


// WEBPACK FOOTER //
// ./src/state/inventory/configuration/services/service.ts